import React from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { LeftCard, RightCard } from '@sandtech-hub-monorepo/ui-kit';
import { CreatePasswordForm } from './components/CreatePasswordForm';

import { Loader2 } from 'lucide-react';
import { useCognito } from '@sandtech-hub-monorepo/ui-auth-kit';

export interface CreatePasswordProps {
  resetPasswordRoute: string;
  homeRoute: string;
  loginCover: string;
}

export const CreatePassword = (props: CreatePasswordProps) => {
  const { currentUser, loading, confirmSignIn } = useCognito();

  const [params] = useSearchParams();
  const navigate = useNavigate();

  if (currentUser) {
    navigate({
      pathname: props.homeRoute,
      search: params.toString(),
    });
  }

  return (
    <>
      <LeftCard backgroundImage={props.loginCover} />
      <RightCard>
        {loading ? (
          <div className="flex items-center justify-center gap-2">
            <Loader2 className="animate-spin" />
            Loading ...
          </div>
        ) : (
          <>
            <div className="flex flex-col space-y-2">
              <h1 className="text-2xl font-semibold tracking-tight">
                Welcome back!
              </h1>
              <p className="text-sm text-muted-foreground">
                You need to update your password.
              </p>
            </div>
            <CreatePasswordForm
              onSubmit={confirmSignIn}
              loading={loading}
              resetPasswordRoute={props.resetPasswordRoute}
            />
          </>
        )}
      </RightCard>
    </>
  );
};
